<template>
  <div
    class="audio-item-generate-box"
    :class="{
      [`audio-item-generate-box--${createRenderType}`]: true,
      'audio-item-generate-box-first': props.index == 0,
      'audio-item-generate-box--regionedit':
        props.pitem?.generation_method == 3 &&
        props.pitem?.is_generated_from_uploaded_file,
      'audio-item-generate-box--extend':
        props.pitem?.generation_method == 2 &&
        props.pitem?.is_generated_from_uploaded_file,
    }"
  >
    <div class="audio-item-generate">
      <div
        class="audio-item-box-loading rotate-loading"
        v-if="
          ![2, 3].includes(props.pitem?.generation_method) ||
          !props.pitem?.is_generated_from_uploaded_file
        "
      >
        <!-- <LoaderCircle
          :loading="true"
          :size="20"
          color="#94ADFF"
          :marginSize="2"
          :strokeWidth="2"
        ></LoaderCircle> -->
      </div>

      <div
        class="audio-item-box-loading-proress-box"
        v-if="
          props.pitem?.generation_method == 3 &&
          props.pitem?.is_generated_from_uploaded_file
        "
      >
        <LoaderCircle
          :loading="true"
          :size="createRenderType == 'mobile' ? 42 : 48"
          color="#FFC17E"
          :strokeWidth="2"
        >
        </LoaderCircle>
        <div class="audio-item-box-loading-content flex-center">
          <i class="block icon icon-loading-regionedit"></i>
        </div>
      </div>

      <div
        class="audio-item-box-loading-proress-box"
        v-if="
          props.pitem?.generation_method == 2 &&
          props.pitem?.is_generated_from_uploaded_file
        "
      >
        <LoaderCircle
          :loading="true"
          :size="createRenderType == 'mobile' ? 42 : 48"
          color="#6DE5C7"
          :strokeWidth="2"
        >
        </LoaderCircle>
        <div class="audio-item-box-loading-content flex-center">
          <i class="block icon icon-loading-extend"></i>
        </div>
      </div>

      <div
        class="audio-item-box-waiting-text flex1 width-0"
        v-if="props.pitem?.state == 1"
      >
        <span
          class="block"
          v-if="
            props.pitem?.generation_method == 2 &&
            props.pitem?.is_generated_from_uploaded_file
          "
        >
          {{
            $$tValue("editor.wait_num_in_queue_extend", {
              wait_num: props.pitem?.wait_num ?? 1,
            })
          }}
        </span>
        <span
          class="block"
          v-if="
            props.pitem?.generation_method == 3 &&
            props.pitem?.is_generated_from_uploaded_file
          "
        >
          {{
            $$tValue("editor.wait_num_in_queue_reginion_edit", {
              wait_num: props.pitem?.wait_num ?? 1,
            })
          }}
        </span>
        <span
          class="block"
          v-if="
            !(
              props.pitem?.is_generated_from_uploaded_file &&
              [2, 3].includes(props.pitem?.generation_method)
            )
          "
        >
          {{
            $$t("create.wate_num_in_queue").replace(
              "[wait_num]",
              props.pitem?.wait_num ?? 1
            )
          }}
        </span>
      </div>
      <div
        class="audio-item-box-waiting-text flex1 width-0"
        v-show="props.pitem?.state == 2"
      >
        {{ $$t("create.generating") }}
      </div>

      <div class="audio-item-box-btns">
        <div class="fn-inline audio-item-box-btn">
          <Button
            @click="doCancel"
            :renderStyle="{
              '--padding': '0 12px',
              '--width': 'max-content',
              '--height': '32px',
              '--borderRadius': '50px',
              '--background': 'rgba(255, 255, 255, 0.1)',
              '--fontColor': '#fff',
              '--fontSize': '14px',
              '--fontWeight': 'normal',
              '--border': 'none',
              '--backgroundHover': 'rgba(255, 255, 255, 0.2)',
              '--fontColor': '#fff',
            }"
          >
            {{ $$t("create.cancel") }}
          </Button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {
  ref,
  defineProps,
  defineEmits,
  computed,
  readonly,
  reactive,
  watch,
  defineExpose,
  onMounted,
  onUpdated,
  onUnmounted,
} from "vue"

import Button from "@/components/basic/button/Button.vue"
import LoaderCircle from "@/components/animation/LoaderCircle.vue"
// import LoaderProgressCircle from "@/components/animation/LoaderProgressCircle.vue"


import { storeToRefs } from "pinia"
import useCreateLayoutStore from "@/store/create/createLayoutStore.js"
const createLayoutStore = useCreateLayoutStore()
const { createRenderType } = storeToRefs(createLayoutStore)
const { $$language, $$t, $$tm, $$tValue } = getCurrentInstance().appContext?.config.globalProperties.$i18n ?? {}

const props = defineProps({
  index: {
    type: Number,
    default: 0,
  },
  pitem: {
    type: Object,
    default: null,
  },
  listRenderType: {
    type: String,
    default: "createdresult", // mysong, likemysong, createdresult
  },
  state: {
    type: Number,
    default: 0, // 0:未生成 1:排队中 2:生成中 3:生成成功 4, 6, 10, 11:生成失败
  },
})
const emits = defineEmits(["cancel", "restore"])

const renderData = reactive({
  progress: 0,
})

const updateRenderProgress = () => {
  requestAnimationFrame(() => {
    const now = new Date().getTime()
    const { generate_at, estimate_over_at } = props.pitem
    // console.log("updateRenderProgress", generate_at, estimate_over_at, now)
    const progress =
      (now - generate_at * 1000) / ((estimate_over_at - generate_at) * 1000)
    renderData.progress = Math.max(0, Math.min(99, progress))
    if (renderData.mouted) {
      updateRenderProgress()
    }
  })
}

const doCancel = () => {
  emits("cancel", props.pitem)
}

const doFrom = () => {
  emits("from", props.pitem)
}

onMounted(() => {
  renderData.mouted = true
  // if ([2, 3].includes(props.pitem?.generation_method)) {
  //   updateRenderProgress()
  // }
})
onUnmounted(() => {
  renderData.mouted = false
})
</script>
<style lang="scss" scope>
.audio-item-generate-box {
  padding: 6px 20px;
  // &:hover {
  //  background: rgba(255, 255, 255, 0.1);
  // }
  &.audio-item-generate-box-first {
    padding-top: 12px;
  }
  .audio-item-generate {
    display: flex;
    align-items: center;
    padding: 16px 20px;
    border-radius: 12px;
    background: rgba(148, 173, 255, 0.15);
    backdrop-filter: blur(20px);
    justify-content: space-between;
  }
  .audio-item-box-loading {
    width: 20px;
    height: 20px;
    background: url(@/assets/img/loading-mini-3x.png);
    background-size: 100% 100%;
  }

  .audio-item-box-loading-proress-box {
    background: rgba(0, 0, 0, 0.5);
    border-radius: 50%;
    position: relative;
    .loader-progress {
      margin: -1px;
    }
  }
  .audio-item-box-loading-content {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    i {
      height: 24px;
      width: 24px;
      &.icon-loading-regionedit {
        background: url(@/assets/img/wait-generate-redionedit.png);
        background-size: 100% 100%;
      }
      &.icon-loading-extend {
        background: url(@/assets/img/wait-generate-extend.png);
        background-size: 100% 100%;
      }
    }
  }

  .audio-item-box-btn {
    margin-left: 8px;
  }
  .audio-item-box-waiting-text {
    font-family: HarmonyOS Sans SC;
    font-size: 16px;
    font-weight: 500;
    line-height: 20px;
    min-height: 36px;
    color: #94adff;
    padding: 0 10px;
    display: flex;
    align-items: center;
  }
  &.audio-item-generate-box--mobile {
    padding: 12px 16px 12px 20px;
    .audio-item-generate {
      padding: 10px 12px;
    }
    .audio-item-box-waiting-text {
      font-size: 14px;
      line-height: 18px;
    }
  }

  &.audio-item-generate-box--regionedit {
    .audio-item-generate {
      background: rgba(255, 190, 121, 0.2);
    }
    .audio-item-box-waiting-text {
      color: #ffc17e;
      padding: 0 10px 0 16px;
    }
  }
  &.audio-item-generate-box--extend {
    .audio-item-generate {
      background: rgba(109, 229, 199, 0.2);
    }
    .audio-item-box-waiting-text {
      color: #6de5c7;
      padding: 0 10px 0 16px;
    }
  }
}
</style>
